if (import.meta.hot) {
  import.meta.hot.accept();
}

import '../Scss/form.scss';
import '../Scss/altcha.scss';

// Helper function: Finds the .inputs-list parent element
function findInputsList(element) {
  let current = element;
  while (current && current !== document.body) {
    if (current.classList.contains('inputs-list')) {
      return current;
    }
    current = current.parentElement;
  }
  return null;
}

// Helper function: Inserts error message at the correct location
function insertErrorMessage(input, errorDiv) {
  const inputType = input.type;

  // For radios and checkboxes in .inputs-list
  if ((inputType === 'radio' || inputType === 'checkbox')) {
    const inputsList = findInputsList(input);
    if (inputsList) {
      // Check if error message already exists in inputs-list
      const existingError = inputsList.parentElement.querySelector('.error-message');
      if (existingError) {
        return existingError;
      }

      const parent = inputsList.parentElement;
      const formText = parent.querySelector('.form-text');

      if (formText) {
        parent.insertBefore(errorDiv, formText);
      } else {
        parent.appendChild(errorDiv);
      }
      return errorDiv;
    }
  }

  // For all other inputs and selects
  const parent = input.parentElement;
  const formText = parent.querySelector('.form-text');

  if (formText) {
    parent.insertBefore(errorDiv, formText);
  } else {
    parent.appendChild(errorDiv);
  }

  return errorDiv;
}

// Helper function: Finds the associated error message
function findErrorMessage(input) {
  const inputType = input.type;

  // For radios and checkboxes in .inputs-list
  if ((inputType === 'radio' || inputType === 'checkbox')) {
    const inputsList = findInputsList(input);
    if (inputsList) {
      return inputsList.parentElement.querySelector('.error-message');
    }
  }

  // For all other inputs and selects
  return input.parentElement.querySelector('.error-message');
}

document.querySelectorAll('input[required], textarea[required], select[required]').forEach(input => {
  input.addEventListener('invalid', function(e) {
    e.preventDefault(); // Prevent native tooltip
    this.classList.add('is-invalid');

    // Check if error message already exists
    let errorDiv = findErrorMessage(this);

    if (!errorDiv) {
      // Create an error div and insert it at the correct position
      errorDiv = document.createElement('div');
      errorDiv.classList.add('error-message');
      errorDiv = insertErrorMessage(this, errorDiv);
    }

    // Use the browser's native error message
    errorDiv.textContent = this.validationMessage;
  });

  input.addEventListener('input', function() {
    const inputType = this.type;

    // For radios: handle all radios in the same group
    if (inputType === 'radio') {
      const inputsList = findInputsList(this);
      if (inputsList) {
        // Remove is-invalid from all radios with the same name
        const radioGroup = inputsList.querySelectorAll(`input[type="radio"][name="${this.name}"]`);
        radioGroup.forEach(radio => radio.classList.remove('is-invalid'));

        // Remove error message
        const errorDiv = findErrorMessage(this);
        if (errorDiv) {
          errorDiv.remove();
        }
        return;
      }
    }

    // For checkboxes: only remove when all are valid
    if (inputType === 'checkbox') {
      const inputsList = findInputsList(this);
      if (inputsList) {
        const allCheckboxes = inputsList.querySelectorAll('input[type="checkbox"][required]');
        const anyChecked = Array.from(allCheckboxes).some(cb => cb.checked);

        if (anyChecked) {
          allCheckboxes.forEach(cb => cb.classList.remove('is-invalid'));
          const errorDiv = findErrorMessage(this);
          if (errorDiv) {
            errorDiv.remove();
          }
        }
        return;
      }
    }

    // For all others: remove directly
    this.classList.remove('is-invalid');
    const errorDiv = findErrorMessage(this);
    if (errorDiv) {
      errorDiv.remove();
    }
  });

  // Additional event listener for 'change' on radios and checkboxes
  if (input.type === 'radio' || input.type === 'checkbox') {
    input.addEventListener('change', function() {
      // Trigger input event to reuse the logic
      this.dispatchEvent(new Event('input', { bubbles: true }));
    });
  }
});

document.querySelectorAll('form').forEach(form => {
  form.addEventListener('submit', function () {
    const ce = this.closest('.ce');
    const header = ce ? ce.querySelector('.ce-header') : null;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'form_submit',
      form_id: this.id,
      form_name: header ? header.textContent.trim() : '',
    });
  });
});
